import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const API_SETTINGS_URL = getBaseUrl('/settings/');

export async function getSettings() {
    return await appRequest.doGetRequest(API_SETTINGS_URL);
}

export async function updateSettings(settings) {
    return await appRequest.doPatchRequest(API_SETTINGS_URL, settings);
}

// "Começar a contar de agora": fixa a marca d'água do skim no lucro realizado atual.
export async function setSkimBaseline() {
    return await appRequest.doPostRequest(`${API_SETTINGS_URL}skimBaseline`, {});
}

export async function getLoadProfiles() {
    return await appRequest.doGetRequest(`${API_SETTINGS_URL}loadProfiles`);
}

// Checagem ADVISORY de viabilidade de capital no setup: o saldo livre sustenta topN fatias
// acima do mínimo viável? Fail-open no backend (sem credencial → { available:false }).
export async function getCapitalCheck({ topN, type = 'grid', levels, quote = 'USDT', environment } = {}) {
    const qs = new URLSearchParams();
    if (topN != null) qs.set('topN', topN);
    if (type) qs.set('type', type);
    if (levels != null) qs.set('levels', levels);
    if (quote) qs.set('quote', quote);
    if (environment) qs.set('environment', environment);
    return await appRequest.doGetRequest(`${API_SETTINGS_URL}capitalCheck?${qs.toString()}`);
}

// Ledger de capital do usuário (item 2): pizza/reserva spot + bloco de futuros, deployado por estratégia.
export async function getCapitalLedger(environment) {
    const qs = environment ? `?environment=${environment}` : '';
    return await appRequest.doGetRequest(`${API_SETTINGS_URL}capitalLedger${qs}`);
}

export async function doTestEmail() {
    return await appRequest.doGetRequest(`${API_SETTINGS_URL}testEmail`);
}

export async function doTestSms() {
    return await appRequest.doGetRequest(`${API_SETTINGS_URL}testSms`);
}

export async function doTestTelegram() {
    return await appRequest.doGetRequest(`${API_SETTINGS_URL}testTelegram`);
}

export async function getTelegramChatId() {
    return await appRequest.doGetRequest(`${API_SETTINGS_URL}telegramChatId`);
}

export async function getAiUsage() {
    return await appRequest.doGetRequest(`${API_SETTINGS_URL}aiUsage`);
}

export async function doTestAi() {
    return await appRequest.doGetRequest(`${API_SETTINGS_URL}testAi`);
}

export async function doQuickSetup() {
    return await appRequest.doPostRequest(`${API_SETTINGS_URL}quickSetup`, {});
}

export async function cleanupData(items, environment, confirm, market) {
    const body = { items, environment, confirm };
    if (market) body.market = market; // 'spot' | 'futures' — escopa por mercado (omitir = ambos)
    return await appRequest.doPostRequest(`${API_SETTINGS_URL}cleanup`, body);
}

// Política de ambiente (2 camadas): retorna systemMode, effectiveMode, allowed, locked, source.
export async function getEnvironmentPolicy() {
    return await appRequest.doGetRequest(getBaseUrl('/environment/policy'));
}

// Política de mercado (2 camadas): retorna { futures: { systemEnabled, effectiveEnabled, locked, source } }.
export async function getMarketPolicy() {
    return await appRequest.doGetRequest(getBaseUrl('/market/policy'));
}

// Snapshot 24h de mercado via REST (o feed WS !ticker@arr da Binance morreu). Alimenta o
// "Mercado 24h" + "Book" da dashboard. Retorna { ticker: {SYM:{...}}, book: {SYM:{...}} }.
export async function getMarketTicker24h() {
    return await appRequest.doGetRequest(getBaseUrl('/market/ticker24h'));
}

// Liquidez (volume 24h) dos símbolos — aviso de baixa liquidez na criação de estratégia.
// symbols: array de pares (ex: ['BTCUSDT','ETHUSDT']). Retorna { symbols: {SYM:{quoteVolume,low}}, threshold }.
export async function getMarketLiquidity(symbols) {
    const q = (symbols || []).join(',');
    return await appRequest.doGetRequest(getBaseUrl(`/market/liquidity?symbols=${encodeURIComponent(q)}`));
}